import React from "react";
import { useNarrowViewport } from "../Shared/useNarrowViewport.ts";

/**
 * The intro paragraphs of a game, quiz or flash-card page (ADR 0116 §2). On a
 * phone only the first sits between the h1 and the tool, so the first screen
 * shows the page's name, what it does and the start of the tool; `IntroRest`
 * puts the others after the tool, before the FAQ.
 *
 * On a wide screen every paragraph stays under the h1, as in the static page
 * `prerender.js` writes. The tool is already on a desktop's first screen, and
 * moving the paragraphs there let React repaint one a pixel taller than its
 * static copy, which Chrome counts as a later, larger LCP (the 0116 amendment).
 *
 * Same width as the workbench's phone layout (`WORKBENCH_NARROW`, ADR 0061 §7),
 * restated here so a game page does not import the generator.
 */
export const TOOL_FIRST = "(max-width: 899px)";

function Paragraphs({ paragraphs, start }: { paragraphs: string[]; start: number }) {
    return (
        <>
            {paragraphs.map((paragraph, i) => (
                <p key={start + i}>{paragraph}</p>
            ))}
        </>
    );
}

/** Under the h1: the first paragraph on a phone, all of them on a wide screen. */
export function IntroLead({ paragraphs }: { paragraphs?: string[] }) {
    const toolFirst = useNarrowViewport(TOOL_FIRST);
    if (!paragraphs) return null;
    return <Paragraphs paragraphs={toolFirst ? paragraphs.slice(0, 1) : paragraphs} start={0} />;
}

/** After the tool, on a phone only: every paragraph after the first. */
export function IntroRest({ paragraphs }: { paragraphs?: string[] }) {
    const toolFirst = useNarrowViewport(TOOL_FIRST);
    if (!toolFirst || !paragraphs || paragraphs.length < 2) return null;
    return (
        <div className="landingContent landingContentRest">
            <Paragraphs paragraphs={paragraphs.slice(1)} start={1} />
        </div>
    );
}
